import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TreeNodeService } from '../../../../tree-node.service';
import { TreeNodeFilterOptions } from '../../models/TreeNodeFilterOptions';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { ModalComponent } from '../../../../../../shared/components/dialogs/modal/modal.component';

@Component({
  selector: 'app-tree-filter-modal',
  templateUrl: './tree-filter-modal.component.html',
  styleUrls: ['./tree-filter-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ModalComponent, MatCheckboxModule, ReactiveFormsModule, FormsModule, TranslateModule],
})
export class TreeFilterModalComponent {
  private dialogRef = inject<MatDialogRef<TreeFilterModalComponent>>(MatDialogRef);

  private treeNodeService: TreeNodeService;

  readonly filterOptions: TreeNodeFilterOptions;

  constructor() {
    const data = inject<{
      treeNodeService: TreeNodeService;
    }>(MAT_DIALOG_DATA);

    this.treeNodeService = data.treeNodeService;
    if (!this.treeNodeService.filterOptions) {
      this.dialogRef.close();
      return;
    }
    this.filterOptions = JSON.parse(JSON.stringify(this.treeNodeService.filterOptions));
  }

  onSave() {
    this.treeNodeService.filterOptions = this.filterOptions;
    this.dialogRef.close();
  }
}
